import { registerFr } from '../i18n/index.js';

registerFr({
  'Organisations': 'Organisations',
  'loading…': 'chargement…',
  'with an open deal': 'avec une affaire ouverte',
  'clients': 'clientes',
  'New organisation': 'Nouvelle organisation',
  '{name} created': '{name} créée',
  'Could not create the organisation.': "Impossible de créer l'organisation.",
  'organisations on the record, not archived': 'organisations au dossier, non archivées',
  'Monitored': 'Surveillées',
  'registry, website and news monitors arrive in milestone M5': 'les veilles registre, site et presse arrivent au jalon M5',
  'Open deals': 'Affaires ouvertes',
  'face value': 'valeur nominale',
  'Signals · 7d': 'Signaux · 7 j',
  'no monitor has run yet': "aucune veille n'a encore tourné",
  'With a signal': 'Avec un signal',
  'monitors in all': 'veilles en tout',
  'runs in 24h': 'passages en 24 h',
  'the monitors could not be read': 'les veilles n’ont pas pu être lues',
  'waiting for a decision': 'en attente de décision',
  'Clients': 'Clientes',
  'linked to Signet engagements': 'liées à des mandats Signet',
  // 'All' alone is claimed by InboxPage ('Tous', masculine); an organisation is feminine in
  // French, so this chip carries its own key rather than fighting for the shared one.
  'All organisations': 'Toutes',
  'Active': 'Active',
  'Dormant': 'Dormante',
  'Name, UID, domain…': 'Nom, IDE, domaine…',
  'No organisation matches this filter.': 'Aucune organisation ne correspond à ce filtre.',
  'No organisation has been recorded yet. Add one, or run the seed import.': "Aucune organisation n'est encore enregistrée. Ajoutez-en une, ou lancez l'import de départ.",
  'Name': 'Nom',
  '{n} person': '{n} personne', '{n} people': '{n} personnes',
  'no open deal': 'aucune affaire ouverte',
  'client': 'cliente',

  // ── round 4 : le chercheur de doublons. Il propose ; la revue décide. ──
  'Find duplicates': 'Chercher les doublons',
  'Looking…': 'recherche…',
  'Look for organisation rows that are the same organisation. It proposes; nothing merges without a click in Review.':
    'Chercher les lignes d’organisation qui sont une seule et même organisation. Il propose ; rien ne fusionne sans un clic dans la revue.',
  '{n} pairs proposed · {m} already decided · {k} pending in Review':
    '{n} paires proposées · {m} déjà décidées · {k} en attente dans la revue',
  'The duplicate finder could not run. Nothing was proposed.':
    'Le chercheur de doublons n’a pas pu s’exécuter. Rien n’a été proposé.',

  // ── les unités d'une ligne du tableau ──
  '{n} unit': '{n} unité',
  '{n} units': '{n} unités',
  '{n} in this tree, units included': '{n} dans cet arbre, unités comprises',
}, 'OrganisationsPage');
